// src/components/layout/Sidebar.jsx
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, UserPlus, FileText, LogOut } from 'lucide-react';
import { useAuths } from '../../context/AuthProviders';

const Sidebar = () => {
const { logout } = useAuths();
const navigate = useNavigate();
  // Only include essential links
const navItems = [
    { path: '/hr/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/hr/form', icon: FileText, label: 'Forms' },
    {path: '/hr/dashboard/profile', icon: Users, label: 'Profile'},
  ];

  return (
    <aside className="absolute left-0 top-12 h-100 w-64 bg-gray-900 align-item-stretch text-white flex flex-col">
      {/* Logo / Brand */}
      <div className="p-6 flex items-center space-x-3 border-b border-gray-800 " style={{cursor:'pointer'}} onClick={()=>{
        navigate('/')
      }}>
        <div className="h-10 w-10 bg-blue-500 rounded-lg flex items-center justify-center">
          <Users className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-xl font-bold">HR Portal</h1>
          <p className="text-sm text-gray-400">Management System</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <item.icon className="h-5 w-5" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="p-4 border-t border-gray-800">
        <button className="flex items-center space-x-3 text-gray-300 hover:text-white px-4 py-3 rounded-lg hover:bg-gray-800 w-full transition-colors" onClick={()=>{
         logout();
        }}>
          <LogOut className="h-5 w-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
